var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMergeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.999,
    height: 11,
    viewBox: "0 0 10.999 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union_5",
    "data-name": "Union 5",
    transform: "translate(1443.999 1444)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1440.26-1433v-3.74H-1444V-1444h7.26v3.74h3.74v7.26Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -1433.999877929688 -1433.999877929688 L -1433.999877929688 -1439.259765625 L -1437.739868164062 -1439.259765625 L -1437.739868164062 -1442.999389648438 L -1442.999389648438 -1442.999389648438 L -1442.999389648438 -1437.739868164062 L -1439.259765625 -1437.739868164062 L -1439.259765625 -1433.999877929688 L -1433.999877929688 -1433.999877929688 M -1432.999877929688 -1432.999877929688 L -1440.259765625 -1432.999877929688 L -1440.259765625 -1436.739868164062 L -1443.999389648438 -1436.739868164062 L -1443.999389648438 -1443.999389648438 L -1436.739868164062 -1443.999389648438 L -1436.739868164062 -1440.259765625 L -1432.999877929688 -1440.259765625 L -1432.999877929688 -1432.999877929688 Z",
    stroke: "none",
    fill: "var(--mainColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeIcon);
export default __webpack_public_path__ + "static/media/mergeIcon.e144a062ea805b23267a4960885883b0.svg";
export { ForwardRef as ReactComponent };